export function Multiply({ height, width, fillColor }) {
  return (
    <svg height={height} width={width} viewBox="-34 0 512 512" fill={fillColor}>
      <path d="m386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z" />
    </svg>
  );
}
